import firebase from "firebase";
import Device from "../../models/device";
export const PAIR_DEVICE = "PAIR_DEVICE";
export const SET_DEVICE = "SET_DEVICE";
export const UPDATE_DEVICE_PLAYLIST = "UPDATE_DEVICE_PLAYLIST";
export const UPDATE_DEVICE_SETTING = "UPDATE_DEVICE_SETTING";
export const UPDATE_DEVICE_NAME = "UPDATE_DEVICE_NAME";
export const REMOVE_DEVICE = "REMOVE_DEVICE";
import { useSelector, useDispatch } from "react-redux";

const writeDeviceData = (device) => {
  firebase
    .database()
    .ref("devices/" + device.deviceId)
    .set(device);
};
export const pairDevice = (device) => {
  return async (dispatch) => {
    const response = writeDeviceData(device);

    dispatch({ type: PAIR_DEVICE, newDevice: device });
  };
};

export const removeDevice = (device, socket) => {
  return async (dispatch) => {
    socket.emit("PAIR", {
      command: "UNPAIR REQUEST",
      deviceId: device.deviceId,
    });
    firebase
      .database()
      .ref("devices/" + device.deviceId)
      .remove();
    dispatch({ type: REMOVE_DEVICE, device: device });
    /* 
    socket.on("PAIR", (msg) => {
      console.log(msg);
      const { command, deviceId: rcvdDeviceId } = msg;
      if (command === "UNPAIR ACK" && rcvdDeviceId == device.deviceId) {
        firebase
          .database()
          .ref("devices/" + device.deviceId)
          .remove();
        dispatch({ type: REMOVE_DEVICE, device: device });
      }
    });*/
  };
};

export const updateDevicePlaylist = (deviceId, newPlaylist, socket) => {
  return async (dispatch) => {
    firebase
      .database()
      .ref()
      .child("devices")
      .child(deviceId)
      .child("playlist")
      .set(JSON.parse(JSON.stringify(newPlaylist)));

    // console.log("newPlaylist", newPlaylist);
    socket.emit("PLAYLIST", {
      command: "UPDATE",
      deviceId: deviceId,
      playlist: newPlaylist,
    });

    socket.on("PLAYLIST", (msg) => {
      console.log("PLAYLIST", msg);
      const { command, deviceId: rcvdDeviceId } = msg;
      if (command === "UPDATE ACK" && rcvdDeviceId == deviceId) {
        console.log("PLAYLIST UPDATE ACK RECEIVED");
      }
    });

    dispatch({
      type: UPDATE_DEVICE_PLAYLIST,
      deviceId: deviceId,
      playlist: newPlaylist,
    });
  };
};
export const updateDeviceSetting = (
  deviceId,
  updateField,
  newValue,
  socket
) => {
  return async (dispatch) => {
    firebase
      .database()
      .ref()
      .child("devices")
      .child(deviceId)
      .child("settings")
      .child(updateField)
      .set(newValue);
    socket.emit("SETTINGS", {
      command: "UPDATE",
      deviceId: deviceId,
      field: updateField,
      newValue: newValue,
    });
    console.log("update", deviceId, updateField, newValue);

    socket.on("SETTINGS", (msg) => {
      //console.log(msg);
      const { command, deviceId: rcvdDeviceId } = msg;
      if (command === "UPDATE ACK" && rcvdDeviceId == deviceId) {
        //console.log("SETTINGS UPDATE ACK RECEIVED");
      }
    });

    dispatch({
      type: UPDATE_DEVICE_SETTING,
      deviceId: deviceId,
      updateField: updateField,
      newValue: newValue,
    });
  };
};
export const fetchDevices = () => {
  return async (dispatch, getState) => {
    const userId = firebase.auth().currentUser.uid;

    try {
      let resData;
      const dbRef = firebase.database().ref();
      const response = await dbRef
        .child("devices")
        .get()
        .then((snapshot) => {
          if (snapshot.exists()) {
            resData = snapshot.val();
          } else {
            console.log("No data available");
          }
        })
        .catch((error) => {
          console.error(error);
          throw new Error("Something went wrong!");
        });

      //const resData = await response.json();
      const loadedDevices = [];

      for (const key in resData) {
        loadedDevices.push(
          new Device(
            key,
            resData[key].userId,
            resData[key].name,
            resData[key].settings,
            resData[key].playlist
          )
        );
      }
      console.log("here fetch");
      dispatch({
        type: SET_DEVICE,
        myDevices: loadedDevices.filter((device) => device.userId === userId),
      });
    } catch (err) {
      // send to custom analytics server
      throw err;
    }
  };
};

export const resetDeviceDatabase = () => {
  return async (dispatch, getState) => {
    const userId = firebase.auth().currentUser.uid;

    try {
      let resData;
      const dbRef = firebase.database().ref();
      const response = await dbRef
        .child("devices")
        .remove()
        .catch((error) => {
          console.error(error);
          throw new Error("Something went wrong!");
        });

      //const resData = await response.json();
      const loadedDevices = [];

      dispatch({
        type: SET_DEVICE,
        myDevices: loadedDevices.filter((device) => device.userId === userId),
      });
    } catch (err) {
      // send to custom analytics server
      throw err;
    }
  };
};
export const updateDeviceName = (deviceId, newName, socket) => {
  return async (dispatch) => {
    firebase
      .database()
      .ref()
      .child("devices")
      .child(deviceId)
      .child("name")
      .set(newName);
    dispatch({
      type: UPDATE_DEVICE_NAME,
      deviceId: deviceId,
      newName: newName,
    });
  };
};
